var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cTable',{ref:"table",attrs:{"fields":_vm.fields,"footer":_vm.footer,"config":_vm.config},on:{"checkTable":_vm.checkTable}})}
var staticRenderFns = []

export { render, staticRenderFns }